"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Profiler = void 0;
var profiler_1 = require("./profiler");
Object.defineProperty(exports, "Profiler", { enumerable: true, get: function () { return profiler_1.Profiler; } });
//# sourceMappingURL=index.js.map